module.exports = __webpack_public_path__ + "static/media/CodeQuest3.0 -TY Week 3.dcda54ff.pdf";